import { getSDK as getUnlinkSDK } from "../../sdk/UnlinkInstance";
import bs58 from 'bs58';

/**
 * Checks whether the received message is intended for the current user
 * by verifying if the sharedSecretHint matches one derivable by the client.
 *
 * @param {Object} params
 * @param {Uint8Array} params.ephemeralPublicKey - The ephemeral public key from the message
 * @param {Uint8Array} params.sharedSecretHint - The hint that helps identify the shared secret
 * @param {Uint8Array} params.receiverPrivateKey - The receiver's unlink secret key (Uint8Array)
 *
 * @returns {boolean} - True if the message matches this client
 */
export default function matchSharedSecret({ ephemeralPublicKey, sharedSecretHint, receiverPrivateKey }) {
  try {
    const unlinkSdk = getUnlinkSDK();

    return unlinkSdk.matchesSharedSecretHint({
      ephemeralPublicKey,
      sharedSecretHint,
      receiverPrivateKey,
    });
  } catch (err) {
    console.error("[matchSharedSecret] Matching failed:", err);
    return false;
  }
}